// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/pic-weather-duty.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/pic-weather-duty/latest-weather-rule.js';
import g1 from '../lessons/meteorology/pic-weather-duty/pic-weather-duty.js';

mount([g0, g1]);
